import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from 'common/components/core/header/header.module';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaginationConfig, PaginationModule } from 'ngx-bootstrap/pagination';
import { SidebarModule } from 'common/components/core/sidebar/sidebar.module';
import { VersionModule } from 'common/components/core/version/version.module';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { SmInputModule } from 'common/components/ui-components/sm-input/sm-input.module';
import { SafePipe } from 'common/pipes/safe.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InterceptorService } from 'common/services/core-services/service.interceptor';
import { LoaderModule } from 'common/components/core/loader/loader.module';
import { StarRatingModule } from 'angular-star-rating';
import { LoginDataService } from 'common/services/data-services/admin/login/login-form/login-data.services';
import { FeedbackModule } from 'common/pages/feedback-/feedback/feedback.module';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { CapitalizePipe } from 'common/pipes/capitalize-pipe';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { MentorMappingListDataService } from 'common/services/data-services/custom-service/mentor-list-service';
import { MentorBatchListDataService } from 'common/services/data-services/custom-service/mentor-batch-service';
import { StudentCompletedAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentCompletedAssignmentDetails-services';
import { StudentInCompletedAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentInCompletedAssignmentDetails-service';
import { StudentToDoAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentToDoAssignmentDetails-service';
import { StudentUpcomingAssignmentDetailsDataService } from 'common/services/data-services/custom-service/StudentUpcomingAssignmentDetails-service';
import { CategoryListDataService } from 'common/services/data-services/custom-service/categoryList-services';
import { EmailTemplateListDataService } from 'common/services/data-services/custom-service/email-template-list.service';
import { branchCategoryListDataService } from 'common/services/data-services/custom-service/branchCategoryList.service';
import { DepartmentListDataService } from 'common/services/data-services/custom-service/department-list-service';
import { DistrictDataService } from 'common/services/data-services/custom-service/district-data.service';
import { ApplicantFilterCountDataService } from 'common/services/data-services/admin/applicants-dashboard/applicant-filter-count.service';
import { AddBucketService } from 'common/services/data-services/admin/applicants-dashboard/add-bucket.service';
import { RejectApplicantService } from 'common/services/data-services/admin/applicants-dashboard/reject-applicant.service';
import { verifyDocument } from 'common/services/data-services/admin/applicants-dashboard/verify-document.service';
import { ResendLink } from 'common/services/data-services/admin/applicants-dashboard/resend-link.service';
import { ResentApplicant } from 'common/services/data-services/admin/applicants-dashboard/reset-applicant.service';
import { mentorLogsDataService } from 'common/services/data-services/admin/students/mentor-logs-data.service';
import { InternshipStudentListDataService } from 'common/services/data-services/admin/internship/internship-student-list.service';
import { TypesListDataService } from 'common/services/data-services/custom-service/types-service';
import { HighchartsChartModule } from 'highcharts-angular';
import { InternshipDeleteDataService } from 'common/services/data-services/admin/internship/internship-delete-data.service';
import { UnderMaintenanceModule } from 'common/pages/under-maintenance/under-maintenance.module';
import { ConsentDataService } from 'common/services/data-services/custom-service/consent.service';

// export function checkAuth(authService: LoginDataService) {
//   return () => authService.getAuthStatus();
// }

@NgModule({
  declarations: [AppComponent,CapitalizePipe, ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    SmInputModule,
    StarRatingModule.forRoot(),
    HeaderModule,
    SidebarModule,
    UnderMaintenanceModule,
    PaginationModule.forRoot(),
    NgbModule,
    ToastrModule.forRoot(),
    VersionModule,
    LoaderModule,
    HighchartsChartModule,
    FeedbackModule,

  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }, PaginationConfig, DatePipe, SafePipe, BatchListDataService, branchListDataService, CompanyGridDataService, stateListDataService, MentorMappingListDataService, MentorBatchListDataService,StudentCompletedAssignmentDetailsDataService,StudentInCompletedAssignmentDetailsDataService,StudentToDoAssignmentDetailsDataService,StudentUpcomingAssignmentDetailsDataService,CategoryListDataService,EmailTemplateListDataService,branchCategoryListDataService,DepartmentListDataService,DistrictDataService,ApplicantFilterCountDataService,AddBucketService,RejectApplicantService,verifyDocument,ResendLink,ResentApplicant,mentorLogsDataService, InternshipStudentListDataService, TypesListDataService, InternshipDeleteDataService,ConsentDataService],
  bootstrap: [AppComponent],
  // {
  //   provide: APP_INITIALIZER,
  //   useFactory: checkAuth,
  //   deps: [LoginDataService],
  //   multi: true
  // },
})
export class AppModule {}
